<template>
	<div>
		<sf-modal-layout class="qms-xxl mesInfo" :title="getMessage_('QWCC001843')" :show="display" :closeModal="close">
			<div class="sf-flex-column h-100">
				<div class="sf-col sf-col-4 position-relative mb-1" style="min-height: 40px">
					<sf-card class="p-0 h-100 bg-transparent">
						<sf-button
							v-show="false"
							class="position-absolute"
							line
							:style="barcodeMode ? 'left: 50%; bottom: 0' : 'left:50%; top : 0'"
							size="sm"
							:icon="barcodeMode ? 'arrow-up' : 'arrow-bottom'"
							:onClick="() => (barcodeMode = !barcodeMode)"
						>
							{{ getMessage_('QWCC001828') }}
						</sf-button>
					</sf-card>
					<template v-if="barcodeMode">
						<sf-card class="p-0 h-100 card_bg">
							<mes-search @Refresh="refresh" ref="searchView" :scrId="scrId" :mesEqipNo="popupData?.mesEqipNo"></mes-search>
						</sf-card>
					</template>
				</div>

				<el-tabs type="border-card" class="sf-col-20 no-scroll">
					<el-tab-pane class="mt-2" v-for="(menu, index) in menuList2" :key="index" :label="getMessage_(menu.name)">
						<component
							:is="menu.tag"
							class="px-3 pb-2"
							:scrId="scrId"
							@open="open"
							@ClosePopup="close"
							@PopupOpen="popupOpen"
							@openUbiReport="openUbiReport"
						></component>
					</el-tab-pane>
				</el-tabs>
			</div>
		</sf-modal-layout>
		<!-- 팝업부분 영역 시작 -->
		<user-popup-view ref="userPopupView" @SendData="sendUserData" @Refresh="refresh" :scrId="scrId" />
		<dept-mng-popup-view ref="deptPopupView" @SendData="sendDeptData" :scrId="scrId"></dept-mng-popup-view>
		<!-- ubi 레포트 팝업 -->
		<ubi-report ref="ubiPopup" @Refresh="refresh" :scrId="scrId"></ubi-report>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { serviceComputed, serviceMethods } from '@qms/mmc/mmcm/MesInfo/store/helpers';
import MesSearch from './Table/MesInfoSearch.vue';
import MesInfoBasicForm from '@mmc/mmcm/MesInfo/Content/Popup/Table/MesInfoBasicForm.vue';
import MesInfoHis from '@mmc/mmcm/MesInfo/Content/Popup/Table/MesInfoHis.vue';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
import DeptMngPopupView from '@qms/comm/commpopup/DeptMngPopup/DeptMngPopup.vue';
import UbiReport from '@qms/Components/popup/ReportPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			display: false,
			barcodeMode: true,
			menuList2: [
				{ tag: 'mes-info-basic-form', name: 'QWCC001343' },
				{ tag: 'mes-info-his', name: 'QWCC001359' }
			]
		};
	},
	components: {
		MesSearch,
		MesInfoBasicForm,
		MesInfoHis,
		DeptMngPopupView,
		UserPopupView,
		UbiReport
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		refresh() {
			this.$refs.searchView.searchList();
		},
		async open(param) {
			this.$sf_toggleLoading(true);
			try {
				await this.getCommCodesOnce_(); //한번에 공통코드 가져오기
				await this.getMmcInstList_(); //교정업체 정보는 '부서관리'에서 관리함

				//MMCAD : 측정기 관리자, MMCWK: 측정기 업무처리자, MMCUR : 측정기 일반사용자, OS : 시스템 관리자
				this.setState_({ key: 'isMmcAdmin', value: await this.inclManyUsrGrp_(['MMCAD', 'MMCWK', 'OS']) });
				this.setState_({ key: 'isMmcUser', value: await this.inclManyUsrGrp_(['MMCUR', 'OS']) });

				this.display = true;

				if (param) {
					// 그리드에서 클릭했을때 넘어온 값이 있다면 popupData에 세팅
					await this.onChangeParam_({ key: 'mesEqipNo', value: param.mesEqipNo });
					this.refresh();
				} else {
					this.$sf_toggleLoading(false);
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		close() {
			this.display = false;
			this.$emit('Refresh');
			this.setPopupStateInit_();
		},
		closePopup() {
			this.setPopupStateInit_();
			this.display = false;
		},
		popupOpen(param) {
			if (param === 'dept') this.$refs.deptPopupView.open(this.popupData.useDeptNm);
			else this.$refs.userPopupView.open(param);
		},
		sendUserData(param, userGbn) {
			if (userGbn === 'user1') {
				this.onChangeParam_({ key: 'user1Id', value: param.userId });
				this.onChangeParam_({ key: 'user1Nm', value: param.userName });
				this.onChangeParam_({ key: 'useDeptCd', value: param.deptCd });
				this.onChangeParam_({ key: 'useDeptNm', value: param.deptName });
			} else if (userGbn === 'user2') {
				this.onChangeParam_({ key: 'user2Id', value: param.userId });
				this.onChangeParam_({ key: 'user2Nm', value: param.userName });
			}
		},
		sendDeptData(deptData) {
			this.onChangeParam_({ key: 'useDeptCd', value: deptData.deptCd });
			this.onChangeParam_({ key: 'useDeptNm', value: deptData.deptNm });
		},
		//레포트 출력
		openUbiReport(sendParams) {
			sendParams.ubiTarget = this.ubiTarget;
			this.$refs.ubiPopup.openWindowReport(sendParams);
		}
	}
};
</script>

<style lang="scss">
.mesInfo {
	// .el-dialog__body,
	// .el-tabs__content {
	// 	height: 100% !important;
	// 	width: 100% !important;
	// }
	// .el-tabs__content {
	// 	height: 95% !important;
	// }
}
</style>
